// features/user/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userRole: "",
  requestAction: "add",
  saveBasicDetailsData: {
    basicDetailsInfo: {
      account_name: "",
      activity_type: "",
      cloud_platform: "",
      operation: "",
      service_name: "",
    },
    accountInfo: {},
    configDetailsInfo: {},
  },
  configuration: [{ configurations: {} }],
  approvalTableData: [],
  requestorTableData: {},
};

const devopsSlice = createSlice({
  name: "devops_slice",
  initialState,
  reducers: {
    saveBasicDetails: (state, { payload }) => {
      state.saveBasicDetailsData.basicDetailsInfo = payload;
    },
    getApprovalTableData: (state, { payload }) => {
      state.approvalTableData = payload;
    },
    getConfigurationData: (state, { payload }) => {
      state.configuration = payload;
    },
    setConfigurationFormData: (state, { payload }) => {
      state.saveBasicDetailsData.configDetailsInfo = payload;
    },
    setAccountInfo: (state, { payload }) => {
      state.saveBasicDetailsData.accountInfo = payload;
    },
    setRequestAction: (state, { payload }) => {
      state.requestAction = payload;
    },
    setRequestorTableData: (state, { payload }) => {
      state.requestorTableData = payload;
    },
    setUserRole: (state, { payload }) => {
      state.userRole = payload;
    },
  },
});

export default devopsSlice.reducer;
export const {
  saveBasicDetails,
  getApprovalTableData,
  getConfigurationData,
  setConfigurationFormData,
  setAccountInfo,
  setRequestAction,
  setRequestorTableData,
  setUserRole,
} = devopsSlice.actions;
